<template>
  <div>
    <table class="tabla-pagos">
      <tr>
        <th>Linea</th>
        <th>Columna</th>
        <th>Error/es</th>
      </tr>
      <template v-for="condicion in condiciones">
        <tr v-for="(error, columna, index) in condicion.errores" :key="condicion.linea + '' + index">
        <td>
          {{ condicion.linea }}
        </td>
          <td>
            {{ columna }}
          </td>
          <td>
            {{ error[0] }}
          </td>
        </tr>
      </template>
    </table>
  </div>
</template>

<script>

export default {
  props: {
    condiciones: Array
  }
}
</script>
<style scoped>
.tabla-pagos {
  width: 100%;
}
.tabla-pagos tr:hover {
  background-color: rgb(200, 200, 200);
}
.tabla-pagos th {
  padding-top: 1em;
  border-bottom: 1px solid #bbb;
}
.tabla-pagos td {
  text-align: center;
  border-bottom: 1px solid #bbb;
}
</style>
